import { Data_getInstance25ky60vn7g970 as Data_getInstance } from './adapter/GrantSlackAccessMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { GrantSlackAccessMutation_VariablesAdapter_instance2fh8wjvbv6izy as GrantSlackAccessMutation_VariablesAdapter_instance } from './adapter/GrantSlackAccessMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(grantSlackAccess) {
        this.p6h_1 = grantSlackAccess;
      }
      toString() {
        return 'Data(grantSlackAccess=' + this.p6h_1 + ')';
      }
      hashCode() {
        return this.p6h_1 == null ? 0 : getBooleanHashCode(this.p6h_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.p6h_1 == other.p6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.q6h_1 = 'e874514c291f1d673c3b491e79bafcaaf1514da74fdcb9851c57b44e01a26f89';
        this.r6h_1 = 'grantSlackAccess';
      }
      g6g() {
        return 'mutation grantSlackAccess($input: GrantSlackAccessInput!) { grantSlackAccess(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var GrantSlackAccessMutationClass;
function GrantSlackAccessMutation() {
  if (GrantSlackAccessMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.s6h_1 = input;
      }
      i6g() {
        return 'e874514c291f1d673c3b491e79bafcaaf1514da74fdcb9851c57b44e01a26f89';
      }
      operationId() {
        return this.i6g();
      }
      w48() {
        return Companion_instance.g6g();
      }
      j6g() {
        return 'grantSlackAccess';
      }
      operationName() {
        return this.j6g();
      }
      q47(writer, customScalarAdapters, withDefaultValues) {
        GrantSlackAccessMutation_VariablesAdapter_instance.t6h(writer, this, customScalarAdapters, withDefaultValues);
      }
      p47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'GrantSlackAccessMutation(input=' + this.s6h_1.toString() + ')';
      }
      hashCode() {
        return this.s6h_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantSlackAccessMutation()))
          return false;
        if (!this.s6h_1.equals(other.s6h_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantSlackAccessMutation', VOID, VOID, [Mutation()]);
    GrantSlackAccessMutationClass = $;
  }
  return GrantSlackAccessMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data1rorqhenzwzbc,
  GrantSlackAccessMutation as GrantSlackAccessMutationfs5xfcp7iisz,
};
//endregion

//# sourceMappingURL=GrantSlackAccessMutation.mjs.map
